module.exports = __webpack_public_path__ + "static/media/pay.e2a1f0e0.svg";